<div class="side-nav-panel-content outbounds">
    <div class="outbound-wrapper">
        <ng-container *ngIf="selectedOutboundTasks.length">
            <h4 class="section-header">Selected Flights</h4>
            <div class="outbound-selected__wrapper">
                <button mat-raised-button type="button" color="primary"
                    (click)="assignPickupTasks(selectedOutboundTasks)"
                    [disabled]="disableAssignPickupTasks">Assign/Pickup These Tasks</button>
                <app-outbound-table type="SELECTED" [outboundTasks]="selectedOutboundTasks"
                    [expandedOutbound]="expandedOutbound" (unselectOutbound)="unselectOutbound($event)"
                    (expandOutbound)="expandOutbound($event)"></app-outbound-table>
            </div>
        </ng-container>

        <ng-container *ngIf="outboundDropoffTasks.length">
            <h4 class="section-header">Drop-offs</h4>
            <div class="outbound-dropoffs__wrapper">
                <app-outbound-table type="DROPOFFS" [outboundTasks]="outboundDropoffTasks"
                    [expandedOutbound]="expandedOutbound" (dropOffTask)="dropOffTask($event)"
                    (expandOutbound)="expandOutbound($event)">
                </app-outbound-table>
            </div>
        </ng-container>

        <mat-tab-group animationDuration="0ms">
            <mat-tab *ngFor="let rampGroup of rampGroups" [label]="rampGroup">
                <div class="outbound-unassigned__wrapper">
                    <app-outbound-table [outboundTasks]="outboundTaskMap[rampGroup]"
                        [expandedOutbound]="expandedOutbound" (selectOutbound)="selectOutbound($event, rampGroup)"
                        (expandOutbound)="expandOutbound($event)">
                    </app-outbound-table>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>